import { ViewAllEvents } from "../../data-model/viewAllEvents";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

export interface GetAuditTrialOverviewPayload {
  order_id: string;
}

/**
 * Fetches the full audit trail event list for a PA order.
 *
 * @param payload - Request body containing the order id
 * @returns Parsed view-all audit trail response
 * @throws {Error} When the bearer token is missing or the request fails
 */
export const getViewAllAuditTrail = async (
  payload: GetAuditTrialOverviewPayload,
) => {
  try {
    const token = await getBearerToken();

    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.VIEW_ALL_AUDIT_TRAIL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch audit trial overview");
    }

    const data = await response.json();
    return data as ViewAllEvents;
  } catch (error) {
    logError(error as Error, "Error in getViewAllAuditTrail");
    throw error;
  }
};
